import {
  getMixpanel,
  handleError,
  pushToDataLayer,
} from '@domain-group/fe-helper';
import { getBaseProps, getUserProps } from '..';
import getEntryPoint from '../get-entry-point';
import { getVisibleLandingPageModules } from './modules';
import type { FaaLandingPageModule } from './modules';

const trackViewLandingPage = (
  modules: FaaLandingPageModule[] = getVisibleLandingPageModules(),
): void => {
  try {
    const mixpanel = getMixpanel();
    const entryPoint = getEntryPoint();

    mixpanel.track('Find an Agent Pageview', {
      ...getBaseProps(),
      ...getUserProps(),
      ...(entryPoint && { entryPoint }),
      siteSection: 'Agents',
      modules,
      modulesCount: modules.length,
    });
  } catch (err) {
    handleError(err);
  }
};

export const trackViewLandingPageGa4 = (): void => {
  try {
    pushToDataLayer({ event: 'category_landing_view' });
  } catch (err) {
    handleError(err);
  }
};

export default trackViewLandingPage;
